import { PrimaryButton } from 'components/common/button';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { COLORS, FONTS, STYLES } from 'utils/constants/styles';

const CustomTile = styled.div`
    box-sizing: border-box;
    padding: 40px;
    background-color: ${props => props.theme.background.tileBackground || COLORS.PINK};
    border-radius: ${STYLES.BORDER_RADIUS};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 32px;
    transition: 0.3s ease-out;
    cursor: pointer;
    max-width: 450px;
    min-width: 450px;
    flex: 1;
    height: auto;
    margin: 0 auto;

    :hover {
        transform: scale(1.05);
    }

    .tie-header--text {
        font-size: ${FONTS.HEADER_FONT_SIZE} !important;
        color: ${props => props.theme.background.black} !important;
        text-align: center;
        margin: 0;

        @media (min-width: 799px) {
            font-size: 30px;
        }

        @media (min-width: 1199px) {
            font-size: 40px;
        }
    }
    .tie-body {
        font-size: ${FONTS.DESCRIPTION_FONT_SIZE} !important;
        color: ${props => props.theme.text.black} !important;
        text-align: center;
    }

    @media screen and (max-width: 992px) {
        max-width: 400px;
    }
`;

type Props = {
    header: string;
    description: string;
    imageSrc: string;
    onClick: () => void;
};

const Tile = ({ header, description, imageSrc, onClick }: Props) => {
    const { t } = useTranslation('common');

    return (
        <CustomTile onClick={onClick}>
            <img src={imageSrc} alt="portal icon" />
            <div className="tie-header">
                <p className="tie-header--text">{header}</p>
            </div>
            <div className="tie-body">{description}</div>
            <PrimaryButton style={{ width: '100%', marginTop: '32px' }}>{t('choose')}</PrimaryButton>
        </CustomTile>
    );
};

export default Tile;
